import { request } from './client';
import type { MemberCreated, MemberCreateRequest, MemberInviteSent, MemberPasswordReset, MemberRef } from '@kassa/shared';

// PİN-i yalnız göndərilən sorğuda var; cavabda və ekranda saxlanmır.
export const membersApi = {
  members: () => request<MemberRef[]>('GET', '/api/members'),
  memberPinSet: (id: string, pin: string) =>
    request<{ id: string; pinSet: true }>('PUT', `/api/members/${encodeURIComponent(id)}/pin`, { pin }),
  memberPinClear: (id: string) => request<{ id: string; pinSet: false }>('DELETE', `/api/members/${encodeURIComponent(id)}/pin`),
  memberCreate: (body: MemberCreateRequest) => request<MemberCreated>('POST', '/api/members', body),
  memberPasswordReset: (id: string) =>
    request<MemberPasswordReset>('POST', `/api/members/${encodeURIComponent(id)}/password-reset`),
  memberInviteSend: (id: string) => request<MemberInviteSent>('POST', `/api/members/${encodeURIComponent(id)}/invite`),
  memberSetActive: (id: string, active: boolean) =>
    request<{ id: string; active: boolean }>('POST', `/api/members/${encodeURIComponent(id)}/active`, { active }),
  memberUnlock: (id: string) => request<{ id: string; locked: false }>('POST', `/api/members/${encodeURIComponent(id)}/unlock`),
};
